/**
 * Tutorial Video Player for Help Center
 * Handles YouTube video playback and category navigation
 *
 * Dependencies:
 * - YouTube IFrame API
 * - Swiper.js
 * - help-center-tutorial-data.js (tutorialVideoData, categoryNames)
 */

(function() {
  'use strict';

  var tutorialPlayer;
  var currentCategory = '';
  var currentVideoTitle = 'How to Use NFC in PITAKA iPhone 15 Series Cases: Verify Authenticity and Access PitaStudio';
  var lastClickedCategory = 'phone-cases';
  var swiper_videos;
  var tutorialSelectedCategory = 'phone-cases'; // Independent active state for Tutorials tab
  var categoryBeforeSearch = ''; // Store category before search for restoration

  // Extract video ID from YouTube URL
  function extractVideoId(url) {
    var match = url.match(/[?&]v=([^&]+)/);
    return match ? match[1] : url;
  }

  // Load YouTube IFrame API
  function loadYouTubeAPI() {
    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      initTutorialPlayer();
    }
  }

  // Initialize tutorial video player
  window.onYouTubeIframeAPIReady = function() {
    if (document.getElementById('tutorial_ytplayer')) {
      initTutorialPlayer();
    }
  };

  function initTutorialPlayer() {
    var firstVideoId = 'tkYGRftYeaw'; // Default first video

    tutorialPlayer = new YT.Player('tutorial_ytplayer', {
      height: '100%',
      width: '100%',
      videoId: firstVideoId,
      playerVars: {
        playsinline: 1,
        autoplay: 0,
        modestbranding: 1,
        rel: 0
      },
      events: {
        'onReady': function() {
          document.getElementById('tutorial_video_container').style.backgroundColor = 'transparent';
        }
      }
    });
  }

  // Render video list
  function renderVideoList(videos) {
    var wrapper = document.getElementById('tutorial_video_wrapper');
    if (!wrapper) return;

    wrapper.innerHTML = '';

    videos.forEach(function(video, index) {
      var div = document.createElement('div');
      div.setAttribute('data-id', video.id);
      div.setAttribute('data-title', video.title);
      div.className = 'swiper-slide video-thumbnail flex md:block md:space-y-4 lg:space-y-6';

      div.innerHTML = `
        <div class="video-thumb-wrapper w-4/9 md:w-full">
          <div class="w-full aspect-w-16 aspect-h-9">
            <img src="https://i.ytimg.com/vi/${video.id}/sddefault.jpg"
              alt="${video.title}" class="block w-full h-full object-cover">
          </div>
        </div>
        <div class="w-5/9 md:w-full space-y-1.5 sm:space-y-3 pl-2.5 sm:pl-4 md:pl-0">
          <span class="video-number block text-size-14 xs:text-size-16 sm:text-size-18 md:text-size-20 lg:text-size-24 leading-none">
            #${index + 1}
          </span>
          <h4 class="video-title-wrapper text-size-12 sm:text-size-14 lg:text-size-16 text-grey font-light leading-tight line-clamp-3">
            ${video.title}
          </h4>
        </div>
      `;

      div.addEventListener('click', function() {
        var videoId = this.getAttribute('data-id');
        var videoTitle = this.getAttribute('data-title');
        currentVideoTitle = videoTitle;

        // Update mobile video title
        var mobileTitleEl = document.getElementById('tutorial_current_video_title');
        if (mobileTitleEl) {
          mobileTitleEl.textContent = videoTitle;
        }

        // Play video
        if (tutorialPlayer && tutorialPlayer.loadVideoById) {
          tutorialPlayer.loadVideoById({
            'videoId': videoId,
            'suggestedQuality': 'large'
          });
        }
      });

      wrapper.appendChild(div);
    });

    // Initialize Swiper
    swiper_videos = new Swiper('#tutorial_video_swiper', {
      watchOverflow: true,
      grid: {
        fill: 'row',
        rows: videos.length,
      },
      slidesPerView: 1,
      spaceBetween : 10,
      breakpoints:{
        768: {
          grid: {
            fill: 'row',
            rows: Math.round(videos.length / 2),
          },
          spaceBetween : 16,
          slidesPerView: 2
        },
        1024: {
          grid: {
            fill: 'row',
            rows: 1,
          },
          spaceBetween : 20,
          slidesPerView: 3.2
        },
        1440: {
          grid: {
            fill: 'row',
            rows: 1,
          },
          spaceBetween : 24,
          slidesPerView: 3.6
        },
        1920: {
          grid: {
            fill: 'row',
            rows: 1,
          },
          spaceBetween : 32,
          slidesPerView: 4.2
        }
      }
    });
  }

  // Get subsections from shared utility
  var categorySubsections = {};
  var HelpCenterCommon = window.HelpCenterCommon;

  // Build subsections map from shared category structure
  if (HelpCenterCommon) {
    Object.keys(HelpCenterCommon.categoryStructure).forEach(function(catId) {
      var subsections = HelpCenterCommon.getSubsections(catId);
      if (subsections) {
        categorySubsections[catId] = subsections;
      }
    });
  }

  // Collect all videos from a main category's subsections
  function getAllVideosForCategory(mainCategory) {
    var subsections = categorySubsections[mainCategory];
    if (!subsections) return null;

    var allVideos = [];
    for (var i = 0; i < subsections.length; i++) {
      var subsectionVideos = tutorialVideoData[subsections[i]];
      if (subsectionVideos && subsectionVideos.length > 0) {
        allVideos = allVideos.concat(subsectionVideos);
      }
    }
    return allVideos.length > 0 ? allVideos : null;
  }

  // Scroll to stickyTopContainer's original position (before it becomes sticky)
  function scrollToVideoContainer() {
    var stickyContainer = document.getElementById('stickyTopContainer');
    if (!stickyContainer) {
      return;
    }

    // Get the current position of stickyTopContainer
    var rect = stickyContainer.getBoundingClientRect();
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate the absolute position of stickyTopContainer in the document
    var stickyContainerTop = rect.top + currentScrollTop;

    // If it's already sticky (fixed), we need to find its original position
    // The original position should be where it was before becoming sticky
    if (stickyContainer.classList.contains('is-sticky')) {
      // Get the placeholder height which represents the original space
      var placeholder = document.getElementById('stickyPlaceholder');
      if (placeholder && placeholder.classList.contains('active')) {
        stickyContainerTop = placeholder.getBoundingClientRect().top + currentScrollTop;
      }
    }

    // Add a small offset to show a bit of content above the tabs
    var offset = 20;
    var targetPosition = stickyContainerTop - offset;

    // Ensure we don't scroll to a negative position
    targetPosition = Math.max(0, targetPosition);

    // Smooth scroll to target position
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  // Update navigation active state for Tutorials tab
  function updateTutorialNavActiveState(categoryId) {
    // Update tutorialSelectedCategory
    tutorialSelectedCategory = categoryId;

    // Update mobile tabs
    var mobileTabs = document.querySelectorAll('.mobile-category-tab');
    mobileTabs.forEach(function(tab) {
      if (tab.getAttribute('data-category') === categoryId) {
        tab.classList.add('active', 'text-black', 'font-medium');
        tab.classList.remove('text-grey');

        // Scroll active tab into view
        if (HelpCenterCommon) {
          HelpCenterCommon.scrollTabIntoView(tab, '[Tutorials]');
        }
      } else {
        tab.classList.remove('active', 'text-black', 'font-medium');
        tab.classList.add('text-grey');
      }
    });

    // Update desktop navigation
    // For main categories (with submenus)
    var categoryBtns = document.querySelectorAll('.nav-category-btn');
    categoryBtns.forEach(function(btn) {
      var btnCategory = btn.getAttribute('data-category');
      if (btnCategory === categoryId) {
        btn.classList.add('font-medium');
        // Expand submenu
        var submenu = btn.nextElementSibling;
        if (submenu && submenu.classList.contains('nav-submenu')) {
          submenu.classList.remove('hidden');
          var svg = btn.querySelector('svg');
          if (svg) svg.style.transform = 'rotate(180deg)';
        }
      } else {
        btn.classList.remove('font-medium');
      }
    });

    // For direct category links (without submenus)
    var categoryLinks = document.querySelectorAll('.nav-category-link');
    categoryLinks.forEach(function(link) {
      var linkCategory = link.getAttribute('data-category');
      if (linkCategory === categoryId) {
        link.classList.add('active', 'font-medium');
      } else {
        link.classList.remove('active', 'font-medium');
      }
    });

    // For subcategory links
    var subcategoryLinks = document.querySelectorAll('.subcategory-link');
    subcategoryLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && href === '#' + categoryId) {
        link.classList.add('active', 'font-medium', 'text-black');
        link.classList.remove('text-grey');
      } else {
        link.classList.remove('active', 'font-medium', 'text-black');
        link.classList.add('text-grey');
      }
    });
  }

  // Load videos by category
  function loadVideosByCategory(categoryId) {
    if (currentCategory === categoryId) return;

    currentCategory = categoryId;

    // Clear the stored category for search restoration
    categoryBeforeSearch = '';

    // Clear search input and results when changing category
    var searchInput = document.getElementById('faqSearch');
    var searchResults = document.getElementById('searchResults');
    if (searchInput) {
      searchInput.value = '';
    }
    if (searchResults) {
      searchResults.textContent = '';
    }

    // Update navigation active state for Tutorials
    updateTutorialNavActiveState(categoryId);

    // Scroll to video container
    scrollToVideoContainer();

    var videos;

    // If this is a main category, collect all videos from all subsections
    if (categorySubsections[categoryId]) {
      videos = getAllVideosForCategory(categoryId);
    } else {
      // Otherwise, load videos for the specific subcategory
      videos = tutorialVideoData[categoryId];
    }

    // Update category title
    var categoryTitleEl = document.getElementById('tutorial_category_title');
    if (categoryTitleEl && categoryNames[categoryId]) {
      categoryTitleEl.textContent = categoryNames[categoryId];
    }

    var video_container = document.querySelector('.tutorial-video-container');

    if (videos && videos.length > 0) {
      renderVideoList(videos);

      swiper_videos.update();
      video_container.querySelector('.tutorial-video-empty').classList.add('hidden');
      video_container.querySelector('.tutorial-video-screen').classList.remove('hidden');
      video_container.querySelector('.tutorial-video-list').classList.remove('hidden');

      // Update current video title (mobile)
      currentVideoTitle = videos[0].title;
      var mobileTitleEl = document.getElementById('tutorial_current_video_title');
      if (mobileTitleEl) {
        mobileTitleEl.textContent = currentVideoTitle;
      }

      // Auto-play first video
      if (tutorialPlayer && tutorialPlayer.loadVideoById) {
        tutorialPlayer.loadVideoById({
          'videoId': videos[0].id,
          'suggestedQuality': 'large'
        });
      }
    } else {
      // No videos for this category
      if (swiper_videos && swiper_videos.destroy) {
        swiper_videos.destroy(true, true);
        swiper_videos = null;
      }

      // Clear the wrapper and show empty message
      video_container.querySelector('.tutorial-video-empty').classList.remove('hidden');
      video_container.querySelector('.tutorial-video-screen').classList.add('hidden');
      video_container.querySelector('.tutorial-video-list').classList.add('hidden');

      // Update mobile title to empty state
      var mobileTitleEl = document.getElementById('tutorial_current_video_title');
      if (mobileTitleEl) {
        mobileTitleEl.textContent = 'No videos available';
      }

      // Pause the video player
      if (tutorialPlayer && tutorialPlayer.pauseVideo) {
        tutorialPlayer.pauseVideo();
      }
    }
  }

  // Setup category navigation listeners
  function setupCategoryListeners() {
    var subcategoryLinks = document.querySelectorAll('.subcategory-link');
    var categoryLinks = document.querySelectorAll('.nav-category-link');
    var mobileTabs = document.querySelectorAll('.mobile-category-tab');

    subcategoryLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href && href.indexOf('#') === 0) {
          var categoryId = href.substring(1);

          // Store the clicked category
          lastClickedCategory = categoryId;

          // Check if we're on tutorials tab
          var tutorialsTab = document.getElementById('tutorials-tab');
          if (tutorialsTab && tutorialsTab.classList.contains('active')) {
            // Prevent default scroll behavior when on Tutorials tab
            e.preventDefault();
            // Always call loadVideosByCategory, it will handle both cases
            loadVideosByCategory(categoryId);
          }
        }
      });
    });

    // Handle main category links (Shipping, Order, Refund & Return)
    categoryLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href && href.indexOf('#') === 0) {
          var categoryId = href.substring(1);
          lastClickedCategory = categoryId;

          var tutorialsTab = document.getElementById('tutorials-tab');
          if (tutorialsTab && tutorialsTab.classList.contains('active')) {
            e.preventDefault();
            // Load videos (will show empty state if no videos available)
            loadVideosByCategory(categoryId);
          }
        }
      });
    });

    // Handle mobile category tabs
    mobileTabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        var category = this.getAttribute('data-category');
        if (category) {
          lastClickedCategory = category;

          var tutorialsTab = document.getElementById('tutorials-tab');
          if (tutorialsTab && tutorialsTab.classList.contains('active')) {
            e.preventDefault();
            e.stopPropagation();

            // Update active state using shared utility
            if (HelpCenterCommon) {
              HelpCenterCommon.updateMobileTabState(mobileTabs, tab);
            }

            // Scroll the tab into view using shared utility
            if (HelpCenterCommon) {
              HelpCenterCommon.scrollTabIntoView(tab, '[Tutorials]');
            }

            // Load videos (will show empty state if no videos available)
            loadVideosByCategory(category);
          }
        }
      });
    });

    // Also listen for tab switches
    var tutorialsTabBtn = document.querySelector('[data-tab="tutorials"]');
    if (tutorialsTabBtn) {
      tutorialsTabBtn.addEventListener('click', function() {
        // Update search placeholder
        var searchInput = document.getElementById('faqSearch');
        if (searchInput) {
          searchInput.placeholder = 'Enter a keyword to find tutorial videos';
        }

        // Clear search state when switching to tutorials tab
        categoryBeforeSearch = '';

        // Initialize player if not already done
        if (!tutorialPlayer) {
          setTimeout(function() {
            loadYouTubeAPI();
          }, 500);
        }

        // Restore Tutorials navigation active state
        if (tutorialSelectedCategory) {
          updateTutorialNavActiveState(tutorialSelectedCategory);
        }

        // Load videos for the last clicked category
        if (lastClickedCategory) {
          loadVideosByCategory(lastClickedCategory);
        } else if (currentCategory === '') {
          // Load default main category to show all videos
          loadVideosByCategory('phone-cases');
        } else {
          // Update title for categories without videos
          updateCategoryTitle(lastClickedCategory);
        }
      });
    }
  }

  // Expose setupCategoryListeners globally so FAQ loader can call it after regenerating navigation
  window.tutorialsReattachListeners = setupCategoryListeners;

  // Helper function to update category title
  function updateCategoryTitle(categoryId) {
    var categoryTitleEl = document.getElementById('tutorial_category_title');
    if (categoryTitleEl && categoryNames[categoryId]) {
      categoryTitleEl.textContent = categoryNames[categoryId];
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupCategoryListeners();
    });
  } else {
    setupCategoryListeners();
  }

  // Expose search functions globally for FAQ loader to call
  window.performTutorialSearch = function(query) {
    const searchResults = document.getElementById('searchResults');
    const categoryTitleEl = document.getElementById('tutorial_category_title');
    const video_container = document.querySelector('.tutorial-video-container');

    if (!searchResults || !video_container) {
      return;
    }

    // Store current category before searching
    if (!categoryBeforeSearch) {
      categoryBeforeSearch = currentCategory;
    }

    const lowerQuery = query.toLowerCase();
    var allMatchingVideos = [];

    // Search across all categories in tutorialVideoData
    for (var categoryId in tutorialVideoData) {
      if (tutorialVideoData.hasOwnProperty(categoryId)) {
        var videos = tutorialVideoData[categoryId];
        if (videos && Array.isArray(videos)) {
          videos.forEach(function(video) {
            if (video.title.toLowerCase().includes(lowerQuery)) {
              allMatchingVideos.push(video);
            }
          });
        }
      }
    }

    // Update search results text
    searchResults.className = 'absolute pt-2 text-size-12';
    if (allMatchingVideos.length === 0) {
      searchResults.textContent = `No videos found for "${query}"`;

      // Show empty state
      video_container.querySelector('.tutorial-video-empty').classList.remove('hidden');
      video_container.querySelector('.tutorial-video-screen').classList.add('hidden');
      video_container.querySelector('.tutorial-video-list').classList.add('hidden');
    } else {
      searchResults.textContent = `Found ${allMatchingVideos.length} video${allMatchingVideos.length > 1 ? 's' : ''}`;

      // Update category title to show search keyword
      if (categoryTitleEl) {
        categoryTitleEl.textContent = `"${query}"`;
      }

      // Render the matching videos using the existing renderVideoList function
      renderVideoList(allMatchingVideos);

      // Show video containers
      video_container.querySelector('.tutorial-video-empty').classList.add('hidden');
      video_container.querySelector('.tutorial-video-screen').classList.remove('hidden');
      video_container.querySelector('.tutorial-video-list').classList.remove('hidden');

      // Auto-play first video
      if (tutorialPlayer && tutorialPlayer.loadVideoById && allMatchingVideos.length > 0) {
        tutorialPlayer.loadVideoById({
          'videoId': allMatchingVideos[0].id,
          'suggestedQuality': 'large'
        });

        // Update mobile title
        var mobileTitleEl = document.getElementById('tutorial_current_video_title');
        if (mobileTitleEl) {
          mobileTitleEl.textContent = allMatchingVideos[0].title;
        }
      }
    }
  };

  window.clearTutorialSearch = function() {
    const searchResults = document.getElementById('searchResults');

    // Clear search results text
    if (searchResults) {
      searchResults.textContent = '';
    }

    // Restore the previous category if we have one
    if (categoryBeforeSearch) {
      var tempCategory = currentCategory;
      currentCategory = ''; // Reset so loadVideosByCategory will reload
      loadVideosByCategory(categoryBeforeSearch);
      categoryBeforeSearch = ''; // Clear the stored category
    }
  };
})();
